import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, inject } from '@angular/core';
import { GROWTHBOOK } from '../growthbook';
import { randomString } from '../lib/random-string';
import { BrowserService } from '../services/browser.service';
import { GrowthBookService } from '../services/growth-book.service';
import { StorageService } from '../services/storage.service';

export const growthBookGuard = () => {
  const growthBook = inject(GROWTHBOOK);
  const browserService = inject(BrowserService);
  const growthBookService = inject(GrowthBookService);
  const storage = inject(StorageService);
  const platformId = inject(PLATFORM_ID);

  let visitorId: string;
  if (isPlatformBrowser(platformId)) {
    visitorId = storage.get('visitorId');
    if (!visitorId) {
      visitorId = randomString(32);
      storage.set('visitorId', visitorId);
    }
  }

  growthBook.setAttributes({
    loggedIn: browserService.getCookies()?.['picflow-loggedin'] === 'true',
    visitorId,
  });

  return growthBookService.load();
};
